export function scrollLeft(anims, calcs, stateAnims, dirAnim) {
    let t = anims[dirAnim] + calcs.step * calcs.multiplier;
    anims[dirAnim] = t > 0 ? 0 : t;
    let animationDirection = {};
    animationDirection[dirAnim] = anims[dirAnim].toString() + "px";
    let o = Object.assign(Object.assign({}, stateAnims), { animation: animationDirection });
    return { anims: Object.assign({}, o) };
}
//# sourceMappingURL=scrollLeft.js.map